/* eslint-disable @typescript-eslint/naming-convention */
export enum OrderStatus {
    Unpaid = 'unpaid',
    Pending = 'pending',
    Canceled = 'canceled',
    ReadyToShip = 'ready_to_ship',
    Delivered = 'delivered',
    Returned = 'returned',
    Shipped = 'shipped',
    Failed = 'failed',
    // A failed delivery still travelling back to the shop (LEX last mile
    // only); it turns 'failed' once the items reach shipped_back_success.
    ShippedBack = 'shipped_back',
}
